export enum REQUEST_STATE_CMS {
  CREATED,
  IN_PROGRESS,
  FINISHED,
  APPROVED,
  REJECTED,
  CANCELED,
}
